import { StateCreator, StoreApi } from 'zustand';
import { createStore } from 'zustand/vanilla';

import { FShallowGraph, shallowInitState } from '@spazious/dollhouse-shallow-graph';
import { World } from '@spazious/dollhouse-three';

import { FSetupFetchMethodFunction } from '../types/index.js';

const fetchMethodNotImplemented: FSetupFetchMethodFunction = async () => {
  throw new Error('No fetchMethod provided');
};

const defaultOnError = (err?: Error) => {
  console.error(err);
};
export interface FSetupRootState {
  onError: (err?: Error) => void;
  fetchMethod: FSetupFetchMethodFunction;
  // TODO this should be the root node
  graph: FShallowGraph;
  world: World;
}

export interface FSetupStoreState extends FSetupRootState {
  get: StoreApi<FSetupRootState>['getState'];
  set: StoreApi<FSetupRootState>['setState'];
}

export const fsetupStoreSlice: StateCreator<FSetupStoreState> = (set, get) => ({
  set,
  get,
  fetchMethod: fetchMethodNotImplemented,
  onError: defaultOnError,
  world: null!,
  graph: shallowInitState,
});

export const createFSetupStore = (
  fetchMethod: FSetupFetchMethodFunction,
  onError: (err?: Error) => void = defaultOnError
) =>
  createStore((get, set, store) => ({
    ...fsetupStoreSlice(get, set, store),
    fetchMethod,
    onError,
  })) as FSetupStore;

export type FSetupStore = StoreApi<FSetupStoreState>;

export * from '@spazious/dollhouse-zustand';
